export const AMOUNT_OF_ART = 25
